var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"backgoundUrl"}),_c('div',{staticClass:"NoData"},[_vm._v("暂无数据！")])])])}]

export { render, staticRenderFns }